import { render, staticRenderFns } from "./NewCustomerAddress.vue?vue&type=template&id=4044a706&scoped=true&"
import script from "./NewCustomerAddress.vue?vue&type=script&lang=js&"
export * from "./NewCustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomerAddress.vue?vue&type=style&index=0&id=4044a706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4044a706",
  null
  
)

export default component.exports